import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import {
  fullGradientColors,
  partialGradientColors,
} from "@/components/AIComponents/AiComponents.style";

const ui = constants.colors.ui;
const accentColor = ui.core["500"];
const hoverColor = ui.core["200"];
const white = ui.white["700"];

const buttonStyleCommon = (showLunaAiBranding: boolean): CSSObject => ({
  borderRadius: "100%",
  padding: "4px",
  width: "24px",
  position: "absolute",
  left: "-2px",
  top: "2px",
  ":hover": {
    background: !showLunaAiBranding
      ? hoverColor
      : `linear-gradient(
          279.44deg,
          ${fullGradientColors.position100.color} 4.6%,
          ${fullGradientColors.position50.color} 66.61%,
          ${fullGradientColors.position25.color} 100%
        )`,
    color: white,
    "::before": showLunaAiBranding
      ? {
          content: "''",
          position: "absolute",
          inset: "0",
          left: "0",
          top: "0",
          width: "100%",
          height: "100%",
          background: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))`,
          borderRadius: "100%",
        }
      : {},
  },
});

export const buttonStyleInactive = (
  showLunaAiBranding: boolean,
): CSSObject => ({
  ...buttonStyleCommon(showLunaAiBranding),
  backgroundColor: white,
  color: accentColor,
  ":focus": {
    backgroundColor: white,
    color: accentColor,
  },
});

export const buttonStyleActive = (showLunaAiBranding: boolean): CSSObject => ({
  ...buttonStyleCommon(showLunaAiBranding),
  background: !showLunaAiBranding
    ? accentColor
    : `linear-gradient(
    279.44deg,
    ${partialGradientColors.position100.color} 4.6%,
    ${partialGradientColors.position25.color} 66.61%,
    ${partialGradientColors.position0.color} 100%
  )`,
  color: white,
  ":focus": {
    backgroundColor: accentColor,
    color: white,
  },
});

export const translationModeLayout: CSSObject = {
  paddingInlineStart: "40px",
  position: "relative",
};

export const translatedContentLayout: CSSObject = {
  marginBottom: "30px",
};

export const borderCss = (showLunaAiBranding: boolean): CSSObject => {
  const brandingStyles = showLunaAiBranding
    ? {
        width: "3px",
        background: `linear-gradient(
          279.44deg,
          ${partialGradientColors.position100.color} 4.6%,
          ${partialGradientColors.position25.color} 66.61%,
          ${partialGradientColors.position0.color} 100%
        )`,
      }
    : { border: `2px ${accentColor} solid` };

  return {
    "::before": {
      content: "''",
      height: "100%",
      position: "absolute",
      left: "30px",
      borderRadius: "8px",
      ...brandingStyles,
    },
  };
};
